import api from '../api/api';
const state = () => ({
    testQuestions: null,
    showTestQuestions: false,
    currentQuestion: null,
    selectedAnswers: null,
    showTest: false,
    testComplete: null,
    testSign: null,
    testEducation: 0,
    onboardingSettings: null,
});

const mutations = {
    setTestQuestions(state, data) {
        state.testQuestions = data;
    },
    setShowTestQuestions(state, data) {
        state.showTestQuestions = data;
    },
    setCurrentQuestion(state, data) {
        state.currentQuestion = data;
    },
    setSelectedAnswers(state, data) {
        state.selectedAnswers = data;
    },
    setShowTest(state, data) {
        state.showTest = data;
    },
    setTestComplete(state, data) {
        state.testComplete = data
    },
    setTestSign(state, data) {
        state.testSign = data;
    },
    setTestEducation(state, data) {
        state.testEducation = data;
    },
    setOnboardingSettings(state, data) {
        state.onboardingSettings = data;
    },
};
const getters = {
    getTestQuestions(state) {
        return state.testQuestions;
    },
    getShowTestQuestions(state) {
        return state.showTestQuestions;
    },
    getCurrentQuestion(state) {
        return state.currentQuestion;
    },
    getSelectedAnswers(state) {
        return state.selectedAnswers;
    },
    getShowTest(state) {
        return state.showTest;
    },
    getTestComplete(state) {
        return state.testComplete;
    },
    getTestSign(state) {
        return state.testSign;
    },
    getTestEducation(state) {
        return state.testEducation;
    },
    getOnboardingSettings(state) {
        return state.onboardingSettings;
    },
};

const actions = {
    GET_TEST({ commit }, data) {
        commit('setTestEducation', data.education);
        return api.tests.getTest(
            {
                type: data.type,
                education: data.education,
                game_id: data.game_id
            }
        )
            .then(response => {
                console.log('res', response);
                if (response.data && response.data.data.items && response.data.data.items.length > 0) {
                    commit('setTestQuestions', response.data.data.items);
                    commit('setTestSign', response.data.data.sign);
                }

                return response.data.data;

            })
            .catch(exception => {
                console.log('err', exception)
                return exception.response.data
            }
            )
    },
    GET_ONBOARDING_SETTINGS({ commit }, { gameId }) {
        console.log('RUN GET_ONBOARDING_SETTINGS', { gameId });
        api.tests.getSettings({ gameId }).then(response => {
            if (response.data && Object.keys(response.data.data).length > 0) {
                commit('setOnboardingSettings', response.data.data);
            }

            return response.data.data;
        }).catch(exception => {
            console.log('err', exception);
            return exception.response.data;
        })
    },
    SHOW_TEST({ commit }) {
        commit('setShowTest', true);
    },
    HIDE_TEST({ commit }) {
        commit('setShowTest', false);
        commit('setTestComplete', null);
    },
    SHOW_TEST_QUESTIONS({ commit, state }) {
        commit('setShowTestQuestions', true);
        
        if (state.testQuestions && state.testQuestions.length > 0) {
            commit('setCurrentQuestion', state.testQuestions[0]); 
        }
    },
    HIDE_TEST_QUESTIONS({ commit }) {
        commit('setShowTestQuestions', false);
        commit('setCurrentQuestion', null);
    },
    SET_CURRENT_QUESTION({ commit }, data) {
        commit('setCurrentQuestion', data);
    },
    SET_SELECTED_ANSWERS({ commit }, data) {
        commit('setSelectedAnswers', data);
    },
    SELECT_ANSWER({ commit, state }, data) {
        if (!state.selectedAnswers) {
            commit('setSelectedAnswers', []);
        }

        if (data.multipleAnswers) {
            if (state.selectedAnswers.includes(data.questionAnswer)) {
                let newSelectedAnswers = JSON.parse(JSON.stringify(state.selectedAnswers));
                newSelectedAnswers = newSelectedAnswers.filter(item => item != data.questionAnswer);
                commit('setSelectedAnswers', newSelectedAnswers);
            }
            else {
                let newSelectedAnswers = JSON.parse(JSON.stringify(state.selectedAnswers));
                newSelectedAnswers.push(data.questionAnswer);
                commit('setSelectedAnswers', newSelectedAnswers);
            }
        }
        else {
            let newSelectedAnswers = [];
            newSelectedAnswers.push(data.questionAnswer);
            commit('setSelectedAnswers', newSelectedAnswers);
        }


        let testQuestions = JSON.parse(JSON.stringify(state.testQuestions));
        testQuestions[
            getIndex(testQuestions, state.currentQuestion.id)
        ].selectedAnswers = state.selectedAnswers;
        commit('setTestQuestions', testQuestions);

    },
    ANSWER({ commit, state }, data) {
        commit('setSelectedAnswers', null);
        commit('setCurrentQuestion', null);
        return api.tests.answer(
            data
        )
            .then(response => {
                commit('setTestComplete', response.data.data);
                return response.data.data;
            })
            .catch(exception => {
                return exception.response.data
            }
            )
    }
}
function getIndex(items, id) {
    for (const [index, item] of items.entries()) {
        if (item.id === id) {
            return index;
        }
    }
}
const tests = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
}

export default tests;